<section class="flex justify-content-center mt-4">
  <div class="card-table col-12 flex flex-column">
    <div>
      <CustomTitle [title]="'components.app-control-tiempo.title' | translate"
                   [styleClass]="'font-principal app-title-page-color font-medium font-23 text-uppercase mt-4 '"/>
    </div>
    <custom-table [config]="configTable" [rowExpansionTemplate]="tableRowexpansion"
                  (emitterLazyLoad)="getRecords($event)"/>

    <ng-template #tableRowexpansion let-data>
      <app-rango-tiempo [value]="data"/>
    </ng-template>
  </div>
</section>


<p-dialog [(visible)]="openDialog" [closable]="true" appendTo="body"
          [header]="title()" draggable="false" [modal]="true" (onHide)="hideModal()"
          [breakpoints]="{'2000px': '60vw', '1900px': '60vw', '1700px': '60vw',
           '1400px': '75vw', '960px': '90vw', '640px': '95vw'}">


  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="card p-fluid grid ">
    <div class="field  col-12 md:col-6">
      <label for="nombre">{{ this.translations?.nombre }}</label>
      <input pInputText id="nombre"
             formControlName="nombre"
             placeholder="{{ 'components.app-control-tiempo.placeholder-nombre' | translate }}">
      @if (form.get('nombre')?.invalid && form.get('nombre')?.touched) {
        <app-form-group-error-message [control]="form.get('nombre')"/>
      }
    </div>

    <div class="field  col-12 md:col-6">
      <label for="tipoPlazo">{{ translations?.tipoPlazo }}</label>
      <p-dropdown appendTo="body" optionValue="id" id="tipoPlazo" styleClass="border-round-xl"
                  placeholder="{{ 'components.app-control-tiempo.placeholder-tipoPlazo' | translate }}" formControlName="tipoPlazo"
                  optionLabel="descripcion" [options]="tiposPlazos"></p-dropdown>
      @if (form.get('tipoPlazo')?.invalid && form.get('tipoPlazo')?.touched) {
        <app-form-group-error-message [control]="form.get('tipoPlazo')"/>
      }
    </div>

    <div class="field  col-12 ">
      <label for="descripcion">{{translations?.descripcion }}</label>
      <textarea pInputTextarea id="descripcion"
                formControlName="descripcion"
                placeholder="{{ 'components.app-control-tiempo.placeholder-descripcion' | translate }}"></textarea>
      @if (form.get('descripcion')?.invalid && form.get('descripcion')?.touched) {
        <app-form-group-error-message [control]="form.get('descripcion')"/>
      }
    </div>
    <div class="col-12 justify-content-end">

      <button pButton class="md:w-12rem"
              type="submit" label="{{'form.button.guardar' | translate }}"
              [disabled]="form.invalid" icon="pi pi-check"></button>
    </div>
  </form>
</p-dialog>
